import { CoupleForm } from '@/components/enc/couple-form';

const AddPage = () => <CoupleForm />;

export default AddPage;
